import { motion } from "framer-motion";
import {
  Flame,
  CircleDot,
  Dumbbell,
  BookOpen,
  Coffee,
  Dna,
  Plane,
  GlassWater,
  LayoutGrid,
} from "lucide-react";

const features = [
  { icon: Flame, t: "Calorie Tracking", d: "Log meals and watch macros in real time." },
  { icon: CircleDot, t: "Cycle Tracking", d: "Train smarter around your body's rhythm." },
  { icon: Dumbbell, t: "Strength Training", d: "Log lifts, watch your PRs stack up." },
  { icon: BookOpen, t: "Journal", d: "Track habits and connect the dots over time." },
  { icon: Coffee, t: "Caffeine Tracking", d: "Every coffee, tea and matcha, timed." },
  { icon: Dna, t: "Biological Age", d: "One score showing how you're actually aging." },
  { icon: Plane, t: "Activity Status", d: "Tell Zoku when you're travelling or sick." },
  { icon: GlassWater, t: "Water Tracking", d: "Never miss your hydration goal again." },
  { icon: LayoutGrid, t: "Home Widgets", d: "Style your lock screen with live metrics." },
];

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function FeatureGrid() {
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="feature-grid-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div {...reveal} className="max-w-2xl">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-zoku-orange mb-4">
            And that's not all
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            Nine more <span className="font-editorial text-zoku-orange">quiet superpowers</span>
            {" "}built in.
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <motion.div
              key={f.t}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.04 }}
              className="group rounded-3xl p-6 bg-zoku-bg hover:bg-zoku-orangeLight/60 border border-stone-100 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-2xl bg-white shadow-sm flex items-center justify-center group-hover:bg-zoku-orange group-hover:text-white transition-colors">
                <f.icon className="w-5 h-5 text-zoku-orange group-hover:text-white" />
              </div>
              <h4 className="mt-5 font-heading text-xl font-bold text-zoku-ink">{f.t}</h4>
              <p className="mt-1.5 text-sm text-zoku-ink2 leading-relaxed">{f.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
